import React from "react";
import VSwitch from "../VSwitch/VSwitch.mjs";
import TextLabel from "../TextLabel/TextLabel.mjs";
import enFlag from "./en.svg";
import itFlag from "./it.svg";
import "./LanguageSwitcher.css";
import Glob from "../../libs/Glob.mjs";
import PropTypes from "prop-types";

/**
 * Creates a LanguageSwitcher
 * @version 1.0
 * @author [Marco Balestra](https://altersoftware.it)
 * @requires {Glob.mjs}
 * @requires {VSwitch.mjs}
 * @requires {TextLabel.mjs}
 * @return {JSX.Element}
 */
const LanguageSwitcher = class extends React.Component {
	static propTypes = {
		// active language, defaults to Glob.getLanguage() with automatic update
		lang: PropTypes.string
	}
	constructor(props) {
		super(props);
		this.state = { language: Glob.getLanguage() }
		this.state.items = [
			{ value:'en', label: <div><img src={enFlag} alt={""}/>English</div> },
			{ value:'it', label: <div><img src={itFlag} alt={""}/>Italiano</div> }
		];
		this.uid = Glob.generateUid("LanguageSwitcher");
	}
	componentDidMount() {
		if ( ! this.props.lang ) {
			Glob.register("Prefs", l=>{
				if ( l?.language) this.setState({ language: l?.language });
			}, this.uid);
		}
	}
	componentWillUnmount() {
		if ( ! this.props.lang ) {
			Glob.unregister("Prefs", this.uid);
		}
	}
		render() {
		if ( ! this.state.language ) return "";
		return(
			<div
				className={"LanguageSwitcher"}
				id={this.uid}
				role={"form"}
				aria-label={ <TextLabel value={"Lingua"} /> }
			>
				<VSwitch
					title={ <TextLabel value={"Lingua"} /> }
					current={ this.state.language }
					items={ this.state.items }
					onChange={ (item)=>{ Glob.setLanguage( item.value ) }}
				/>
			</div>
		);
	}
}

export default LanguageSwitcher;